// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GuardrailCategorySchema = z.enum(['AUTHENTICATION','AUTHORIZATION','INPUT_VALIDATION','DATA_EXPOSURE','INJECTION','SESSION_MANAGEMENT','CRYPTOGRAPHY','BUSINESS_LOGIC'] as const);

export type GuardrailCategoryType = `${z.infer<typeof GuardrailCategorySchema>}`

export default GuardrailCategorySchema;
